<div class="iw-image-slider">
    <p-carousel #carousel
                aria-hidden="true"

                [value]="images"
            [responsiveOptions]="_slider_response_options_json"
            [circular]="false"
            [numVisible]="_slider_num_visible"
            [numScroll]="_slider_num_scroll"
            [showIndicators]="_slider_show_indicators"
            [autoplayInterval]="_slider_autoplay_interval"
    >
        <ng-template pTemplate="item" let-image>
            <div class="has-text-centered slider-item" [ngClass]="item_class">
                @if (image.url) {
                <a [href]="image.url" target="_blank">
                    <img [src]="image.path" class="w-full rounded-border" alt="{{image?.alt}}" />
                </a>
                }
                @if (!image.url) {
                <img [src]="image.path" class="w-full rounded-border" alt="{{image?.alt}}" />
                }
            </div>
        </ng-template>
    </p-carousel>
</div>
